import ReferenceApi from "@/api/ReferenceApi";
import IResponseModel from "@/api/ResponseModel";
import { ReferenceViewModel } from "@/models/ViewModels/ReferenceModel";

export default class ReferenceUseCase {
  private readonly _referenceApi: ReferenceApi;

  constructor(referenceApi: ReferenceApi = new ReferenceApi()) {
    this._referenceApi = referenceApi;
  }

  async getAll(): Promise<IResponseModel<ReferenceViewModel>> {
    try {
      const result = await this._referenceApi.getAll();

      return result;
    } catch (error) {
      throw error;
    }
  }

  // private mapReferenceToViewModel(reference: Reference): ReferenceViewModel {
  //   return {
  //     businessSizeBrackets: this.mapReferenceItemsToViewModel(
  //       reference.BusinessSizeBrackets
  //     ),
  //     sponsorshipLevels: this.mapReferenceItemsToViewModel(
  //       reference.SponsorshipLevels
  //     ),
  //     userPermissions: this.mapReferenceItemsToViewModel(
  //       reference.UserPermissions
  //     ),
  //     sponsorshipFrequencies: this.mapReferenceItemsToViewModel(
  //       reference.SponsorshipFrequencies
  //     ),
  //     donorTypes: this.mapReferenceItemsToViewModel(reference.DonorTypes),
  //     userCategories: this.mapReferenceItemsToViewModel(
  //       reference.UserCategories
  //     ),
  //     userRoles: this.mapReferenceItemsToViewModel(reference.UserRoles),
  //     paymentTypes: this.mapReferenceItemsToViewModel(reference.PaymentTypes),
  //     donorPaymentReconciliations: this.mapReferenceItemsToViewModel(
  //       reference.DonorPaymentReconciliations
  //     ),
  //     donorPaymentStatuses: this.mapReferenceItemsToViewModel(
  //       reference.DonorPaymentStatuses
  //     ),
  //     userStatuses: this.mapReferenceItemsToViewModel(reference.UserStatuses),
  //     australianStates: this.mapReferenceItemsToViewModel(
  //       reference.AustralianStates
  //     ),
  //     donorPaymentTypes: this.mapReferenceItemsToViewModel(
  //       reference.DonorPaymentTypes
  //     ),
  //     schoolStatuses: this.mapReferenceItemsToViewModel(
  //       reference.SchoolStatuses
  //     ),
  //     addressTypes: this.mapReferenceItemsToViewModel(reference.AddressTypes),
  //     transactionTypes: this.mapReferenceItemsToViewModel(
  //       reference.TransactionTypes
  //     ),
  //     principalRegistrationStatuses: this.mapReferenceItemsToViewModel(
  //       reference.PrincipalRegistrationStatuses
  //     ),
  //     reconciliationStatuses: this.mapReferenceItemsToViewModel(
  //       reference.ReconciliationStatuses
  //     ),
  //     reconciliationTypes: this.mapReferenceItemsToViewModel(
  //       reference.ReconciliationTypes
  //     ),
  //     fundingRequestTypes: this.mapReferenceItemsToViewModel(
  //       reference.FundingRequestTypes
  //     ),
  //     fundingRequestStatuses: this.mapReferenceItemsToViewModel(
  //       reference.FundingRequestStatuses
  //     ),
  //     fundingPurposes: this.mapReferenceItemsToViewModel(
  //       reference.FundingPurposes
  //     ),
  //   };
  // }

  // private mapReferenceItemsToViewModel(
  //   referenceItems: ReferenceItem[]
  // ): ReferenceItemViewModel[] {
  //   return referenceItems.map((item) => {
  //     return { code: item.Code, name: item.Name };
  //   });
  // }
}
